/**
 * 响应状态
 * @param Success 200 成功
 * @param SuccessAndWarn 205 操作成功，但是有一些警告
 * @param UnLogin 401 未登录
 * @param UnAuthoized 403 未授权
 * @param NotFound 404 未找到
 * @param Error 500 操作错误
 * @param NetWorkError 555 网络异常
 */
enum ResponseCode  {
    /**
     * 200 成功
     */
    Success = 200,
    /**
     * 205 操作成功，但是有一些警告
     */
    SuccessAndWarn = 205,
    /**
     * 401 未登录
     */
    UnLogin = 401,
    /**
     * 403 未授权
     */
    UnAuthoized = 403,
    /**
     * 404 未找到
     */
    NotFound = 404,
    /**
     * 500 操作错误
     */
    Error = 500,
    /**
     * 555 网络异常
     */
    NetWorkError = 555
}

/**
 * 默认值类型
 * @param Custom 0 自定义固定值
 * @param DataLinkage 1 数据联动（查询其他表单值，带过滤条件）
 * @param Formula 2 公式编辑
 */
enum DefaultValueType {
    /**
     * 自定义固定值
     */
    Custom = 0,
    /**
     * 数据联动（查询其他表单值，带过滤条件）
     */
    DataLinkage = 1,
    /**
     * 公式编辑
     */
    Formula = 2
}



/**
 * 下拉待选项类型
 * @param Custom 0 自定义固定值
 * @param DataLinkage 1 数据联动（查询其他表单值，带过滤条件）
 * @param RelationForm 2 关联表单（无查询过滤条件）
 * @param Formula 3 公式编辑
 */
enum ChoiceOptionsDefaultType{
    /**
     * 自定义固定值
     */
    Custom = 0,
    /**
     * 数据联动（查询其他表单值，带过滤条件）
     */
    DataLinkage = 1,
    /**
     * 关联表单（无查询过滤条件）
     */
    RelationForm = 2,
    /**
     * 公式编辑
     */
    Formula = 3
}




/**
 * form 表单操作类型
 * @param Create 0 创建
 * @param Edit 1 编辑
 */
enum FormOperator {
    /**
     * 创建
     */
    Create = 0,
    /**
     * 编辑
     */
    Edit = 1
}

let QweMessage = {
    NetWorkError:"抱歉，网络请求失败！请稍后再试一次"
}

export { ResponseCode, QweMessage, DefaultValueType,FormOperator, ChoiceOptionsDefaultType }